module.exports = __webpack_public_path__ + "static/media/alipay-svg.5274f125.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alipay-svg.svg
// module id = 192
// module chunks = 0